import { Component, OnInit } from '@angular/core';
import { LoginRenderingService } from 'src/app/services/login/login-rendering.service';

@Component({
  selector: 'app-emi-error',
  templateUrl: './emi-error.component.html',
  styleUrls: ['./emi-error.component.scss']
})
export class EmiErrorComponent implements OnInit {

  error: any = new Object();
  text: any;

  constructor(private loginService: LoginRenderingService) { }

  ngOnInit() {
    this.error = this.loginService.emiError;
    //  private int uniqueId; // the error code
    // private String componentId; // not in use
    // private String errorCode ; //
    // private String errorMessage;
    this.text = this.error.errorMessage;

  }

}
